export const selectTimezone = {
	list: (state) => state.utils.timezone.list,
	fetch: (state) => state.utils.timezone.fetch,
};
